import styled from 'styled-components/macro';
import { TYPOGRAPHY } from 'styleguide';

const HeaderTitle = styled.h2`
  padding: 0 0 8px;
  margin: 0;
  ${TYPOGRAPHY.button}
`;

export default HeaderTitle;
